import VueRouter, { Route } from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { RouteName } from '../../../routes/routes.constants';
import { store } from '../../../store';
import { RESPONSIBLE_GAMING_NAMESPACE } from '../../../store/modules/responsible-gaming';
import { config } from '../../config';
import { isRouteActive } from '../helpers/routes';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { getUserJurisdiction } from '../helpers/jurisdiction.helpers';

export function initBettingLimitsGuard(router: VueRouter) {
    router.beforeResolve(async (route: Route, _, next) => {
        const { params, fullPath, meta } = route;
        if (!config.bettingLimitsRequired) {
            return next();
        }

        // Prevents this guard logic to run if the user has already set the limits
        const isBetLimitSet =
            store.getters[
                `${RESPONSIBLE_GAMING_NAMESPACE}/requireBettingLimit`
            ] === false;
        if (isBetLimitSet) {
            return next();
        }

        const user = magic.session.getUser();

        // if user isn't logged in
        if (!user) {
            return next();
        }

        if (!(await isLatvianJurisdiction())) {
            return next();
        }

        // skip if user is in signup route
        if (isRouteActive(RouteName.SIGN_UP_HYBRID, route, router)) {
            return next();
        }

        const isActive = isRouteActive(
            RouteName.SET_BETTING_LIMITS,
            route,
            router,
        );

        // if the modal is open or the user is on the mobile route
        if (meta.allowWithoutBettingLimits || isActive) {
            return next();
        }

        const requireBettingLimits = await store.dispatch(
            `${RESPONSIBLE_GAMING_NAMESPACE}/setRequireBettingLimit`,
        );
        if (!requireBettingLimits) {
            return next();
        }

        return next({
            name: RouteName.SET_BETTING_LIMITS,
            params,
            query: {
                backTo: fullPath,
            },
        });
    });
}

async function isLatvianJurisdiction() {
    return (await getUserJurisdiction()) === Jurisdiction.IAUI;
}
